import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import useApi from '../../hooks/useApi';
import Alert from '../common/Alert';

export default function ForgotPassword() {
  const { post } = useApi();
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const submit = async event => {
    event.preventDefault(); setError(''); setMessage('');
    try { setMessage(await post('/api/auth/forgot-password', { identifier })); }
    catch (err) { setError(err.message); }
  };
  return <div className="auth-page"><section className="auth-panel mx-auto"><div className="card auth-card"><div className="card-body"><span className="auth-form-kicker">Account recovery</span><h3>Forgot password</h3><p className="auth-form-copy">Enter your username or registered email. We will send a time-limited reset link when the account is eligible.</p>{message && <Alert type="success" message={message}/>} {error && <Alert type="danger" message={error}/>}<form onSubmit={submit}><label className="form-label w-100">Username or email<input required maxLength="254" className="form-control mt-1" value={identifier} onChange={e=>setIdentifier(e.target.value)}/></label><button className="btn btn-primary w-100">Send reset link</button></form><p className="auth-switch"><NavLink to="/login">Return to sign in</NavLink></p></div></div></section></div>;
}
